import React from 'react';
import Button from '~/components/base/Button';
import Typography from '~/components/base/Typography';
import './admin-session-warning-modal.scss';

type Props = {
    className?: string,
    countdown: string,
    isExtending: boolean,
    isLeaving: boolean,
    onStay: () => void,
    onLeave: () => void
}

export default function AdminSessionWarningModal({
    className = '',
    countdown,
    isExtending,
    isLeaving,
    onStay,
    onLeave
}: Props): JSX.Element {
    return (
        <div className={`admin-session-warning ${className}`}>
            <Typography size={14} color='dark' className='admin-session-warning__body'>
                This session ends in <b>{countdown}</b>. After that you&apos;ll need a new code
                before you can carry on.
            </Typography>
            {/*
                The part that actually costs them something. Nothing in this flow
                saves a half-finished form, and both endings lose it — locking
                now and letting the clock run out are the same as far as an
                unsaved page is concerned — so the warning has to say so while
                the button to stay is still on screen to act on.
            */}
            <Typography size={12} color='warning' className='admin-session-warning__unsaved'>
                If you lock now, or let it run out, anything you have not saved on this page will
                be lost.
            </Typography>
            <div className='admin-session-warning__actions'>
                <Button
                    label='Keep working'
                    size='lg'
                    className='w-100'
                    isProcessing={isExtending}
                    disabled={isExtending || isLeaving}
                    onClick={onStay} />
                <Button
                    label='Lock now'
                    size='lg'
                    variant='link'
                    className='w-100'
                    isProcessing={isLeaving}
                    disabled={isExtending || isLeaving}
                    onClick={onLeave} />
            </div>
        </div>
    );
}
